<template>
  <div class="body container">
    <!--导航-->
    <div class="nav clearfix">
      <a
        href="javascript:;"
        @click="jumpToList(item.fix_column_name ,item.id)"
        v-for="item in columnData"
        :key="item.id"
        :class="item.id==id?'active':''"
      >{{item.title}}</a>
    </div>

    <!--筛选-->
    <div class="selectWrap">
      <h4 class="tip">筛选</h4>
      <div class="selectBox">
        <div class="common">
          <span class="text">学段:</span>
          <div class="common-box">
            <a
              href="javascrpt:;"
              @click="searchList_section(0)"
              :class="sectionid==0?'active':''"
            >全部</a>
            <a
              href="javascrpt:;"
              @click="searchList_section(item.section_id)"
              v-for="item in sectionData"
              :key="item.section_id"
              :class="sectionid==item.section_id?'active':''"
            >{{item.section_name}}</a>
          </div>
        </div>
        <div class="common">
          <span class="text">学科:</span>
          <div class="common-box">
            <a
              href="javascrpt:;"
              @click="searchList_subject(0)"
              :class="subjectid==0?'active':''"
            >全部</a>
            <a
              href="javascrpt:;"
              v-for="item in subjectData"
              :key="item.id"
              @click="searchList_subject(item.id)"
              :class="subjectid==item.id?'active':''"
            >{{item.name}}</a>
          </div>
        </div>

        <div class="common">
          <span class="text">时间:</span>
          <div class="common-box">
            <div class="select-box">
              <el-select v-model="yearValue" placeholder="学年" @change="search()">
                <el-option
                  v-for="item in yearData"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
              <el-select v-model="termValue" placeholder="学期" @change="search()">
                <el-option
                  v-for="item in term"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--文章资源-->
    <div class="content wrapper clearfix">
      <div class="resourceBox fl">
        <div class="sortBox clearfix">
          <div class="sort fl">
            <a :class="order_by == 0 ? 'active' : ''" @click="orderToList(0)" style="cursor:pointer">最新发布</a>
            <a :class="order_by == 1 ? 'active' : ''" @click="orderToList(1)" style="cursor:pointer">点击最多</a>
          </div>
          <div class="searchBox fr">
            <span class="des">共{{totle}}条结果</span>
            <div>
              <el-input
                v-model="keyword"
                placeholder="关键字搜索，标题"
                class="handle-input mr10 keyword"
                @keyup.enter.native="search"
              ></el-input>
              <a class="searchBtn" @click="search"></a>
            </div>
          </div>
        </div>
        <ul class="resource" v-if="tableData.length">
          <li class="resourceList" v-for="item in tableData" :key="item.id">
            <div class="title">
              <a @click="jumpToInfo(item)" style="cursor:pointer">{{item.title}}</a>
              <span class="time">
                <i></i>
                <em>{{item.create_time}}</em>
              </span>
            </div>
            <div class="intro">{{item.content}}</div>
            <div class="infoBox">
              <span>
                <a href="javascript:;">
                  <img :src="item.url" :alt="item.username" />
                </a>
                <a href="javascript:;">{{item.username}}</a>
              </span>
              <span>专题讨论</span>
              <span>
                <i class="heartIcon"></i>
                <em>{{item.permission_scope==1?'公开':'本校'}}</em>
              </span>
              <span>
                <i class="eyeIcon"></i>
                <em>{{item.view_count}}</em>
              </span>
            </div>
          </li>
        </ul>
        <div class="noData" v-if="none">
          <img src="../../assets/img/no_article.png" alt />
          <p>暂无文章类型资源，去别的地方看看吧~</p>
        </div>
        <div class="btnGroup" style="background: #f6f9fa">
          <div class="pagination">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :hide-on-single-page="true"
              layout="prev, pager, next"
              :total="this.totle"
              :current-page="this.page"
              :page-size="this.pagesize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="getHeight"></div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "class",
  data() {
    return {
      schoolid: this.$route.query.schoolid,
      sectionData: [],
      hotData: [],
      tableData: [],
      columnData: [],
      sectionid: 0,
      subjectData: 0,
      subjectid: 0,
      yearData: [],
      termValue: "",
      pagesize: 12,
      yearValue: "",
      keyword: "",
      order_by: 0,
      page: 1,
      totle: 0,
      id: 0,
      none: false,
      term: [
        {
          key: 0,
          value: "学期"
        },
        {
          key: 1,
          value: "上学期"
        },
        {
          key: 2,
          value: "下学期"
        }
      ],
      login_userid: globalApi.GetUserID(),
      isTerm: false
    };
  },
  computed: {
     globalVaranthasInited(){
         return globalApi.gWebsiteSessionInfo.hasInited;
     }
  },
  watch: {
      globalVaranthasInited: function(){        
        
        this.init();
      },
  },
  
  created() {
    
  },

  methods: {
    init(){
         this.getSection();
        this.getSubject();
        this.getYearList();
        this.getArticleList();
        this.getColumn();
      },
    // 获取二级菜单
    async getColumn() {
      const index = 700;
      this.id = this.$route.query.id;
      const data = {
        s: "WebSchoolSpace.Column.getSubColumns",
        weblevel: 1,
        columnid: index
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      if (response.data.ret != 200) {
        return false;
      }
      if (res.result != 1) {
        return false;
      }
      this.columnData = res.list;
    },
    // 获取学段
    async getSection() {
      const data = {
        s: "WebSchoolSpace.Common.getSection"
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      if (response.data.ret != 200) {
        return false;
      }

      this.sectionData = res;
    },

    // 获取科目
    // async getSubject() {
    //   const data = {
    //     s: "WebSchoolSpace.Common.getSubject",
    //     sectionid: this.sectionid
    //   };
    //   const response = await globalApi.post( data);
    //   const res = response.data.data;
    //   if (response.data.ret != 200) {
    //     return false;
    //   }

    //   if (res.result != 1) {
    //     return false;
    //   }
    //   this.subjectData = res.list;
    // },
    //根据学段获取学科
    async getSubject() {
      const data = {
        s: "WebSchoolSpace.Common.getSubjectBySection",
        section: this.sectionid
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      this.subjectData = res;
    },

    // 获取学年学期
    async getYearList() {
      const data = {
        s: "WebSchoolSpace.Common.getYearList"
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      if (response.data.ret != 200) {
        return false;
      }

      this.yearData = res;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getArticleList();
    },
    // 点击学段
    searchList_section(val) {
      this.page = 1;
      this.sectionid = val;
      this.getSubject();
      this.getArticleList();
    },
    // 点击学科
    searchList_subject(val) {
      this.page = 1;
      this.subjectid = val;
      this.getArticleList();
    },
    // 获取列表
    async getArticleList() {
      document.documentElement.scrollTop = 0;
      const data = {
        s: "WebSchoolSpace.TeachingArticle.searchArticle",
        article_type: 3,
        cul_page: this.page,
        pagesize: this.pagesize,
        sectionid: this.sectionid,
        subjectid: this.subjectid,
        keyword: this.keyword,
        order_by: this.order_by,
        year: this.yearValue,
        term: this.termValue,
        status: 2
      };
      const response = await globalApi.post( data);
      const res = response.data.data;

      if (response.data.ret != 200) {
        return false;
      }
      if (res.result != 1) {
        return false;
      }
      this.totle = res.recordcount;
      this.tableData = res.list;
      this.none = this.tableData.length ? false : true;
    },
    //搜索
    search() {
      this.page = 1;
      this.getArticleList();
    },
    orderToList(val) {
      this.page = 1;
      this.order_by = val;
      this.getArticleList();
    },

    async jumpToInfo(item) {
      const power = globalApi.checkViewPower(item.permission_scope, item.schoolid);
      if (power == 2) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
        return false;
      }
      if (power == 3) {
        this.$message.error("无访问权限!");
        return false;
      }
      globalApi.jumpPath(2, "school_activity_discussion_info", "act_id=" + item.id);
    },
    jumpToList(colName, val) {
      this.$router.push(
        colName + "?id=" + val + "&schoolid=" + this.$route.query.schoolid
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
.btnGroup {
  clear: both;
}
.keyword {
  width: 90%;
}
.select-box .el-select {
  margin-right: 20px;
}
</style>
